import React, { useEffect, useState } from "react";
import "./styles.scss";
import { DropBox, FormHeader, Button, JobsCard } from "../../components";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { CreateNewJob } from "../CreateNewItem";
import { getLanguage } from "../../utils/environment";
import Scrollbars from "react-custom-scrollbars-2";
import { useDispatch, useSelector } from "react-redux";
import { setJobList, setJobs } from "./redux/actions";
import {
  deleteJobs,
  getAllJobs,
} from "../CreateNewItem/CreateNewJob/service/jobs.service";
import AdminJobsCard from "../../components/adminJobsCard";
import { Store } from "react-notifications-component";

const lan = getLanguage();

const Jobs = () => {
  const [viewPointWidth, setViewPointWidth] = useState(0);
  const [viewPointHeight, setViewPointHeight] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [selectJobs, setSelectJobs] = useState("");
  const dispatch = useDispatch();

  const { jobCategoryList, jobList } = useSelector(
    ({ jobsReducer }) => jobsReducer
  );

  const [formData, setFormData] = useState({
    status: {
      key: "status",
      label: "",
      size: "lg",
      placeholder: "Select Status",
      mainLayerStyles: " flex-column " + " align-content-center ",
      iconName: "",
      isRequired: false,
      loading: false,
      elementConfig: {
        options: [],
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
  });

  // scrollbars start
  useEffect(() => {
    updateWindowDimensions();
    window.addEventListener("resize", updateWindowDimensions);
    window.addEventListener("scroll", handleOnScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return () => {
      window.removeEventListener("scroll", handleOnScroll);
      window.removeEventListener("resize", updateWindowDimensions);
    };
  }, []);

  const updateWindowDimensions = () => {
    setViewPointWidth(window.innerWidth);
    setViewPointHeight(window.innerHeight);
  };

  const handleOnScroll = () => {
    let scrollTop =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;
    let scrollHeight =
      (document.documentElement && document.documentElement.scrollHeight) ||
      document.body.scrollHeight;
    let clientHeight =
      document.documentElement.clientHeight || window.innerHeight;
  };
  // scrollbars end

  const onClickRefresh = async () => {
    await fetchData();
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const getList = await getAllJobs();
      console.log("Get All Jobs : ", getList);

      if (getList?.data) {
        dispatch(setJobList(getList.data));
        setIsLoading(false);
      } else {
        console.log("Data Not Found");
      }
    } catch (error) {
      console.log("Error fetching Data", error);
    }
  };

  const fetchOrganizationName = (categoryId) => {
    const jobCategory = jobCategoryList?.find(
      (job) => job.job_category_id === categoryId
    );
    return jobCategory ? jobCategory.jobs_category_name : "-";
  };

  const updateForm = { ...formData };

  return (
    <>
      <div className="hne-jobs-wrapper">
        <div className="col-8 jobs-body-wrapper">
          <FormHeader
            data={{
              formHeader: "Jobs",
              size: "md-md",
            }}
          />

          <div className={"hne-job-action-wrapper"}>
            <div className={"hne-jaw-input-wrapper"}>
              <div style={{ minWidth: "205px" }}>
                <DropBox
                  data={updateForm.status}
                  onChange={(e) => {
                    const updateForm = { ...formData };
                    updateForm["status"].value = e;
                    // setFormData(updateForm);
                    // dispatch(setCategoryDetails(e));
                  }}
                />
              </div>
            </div>
            <div className={"hne-jaw-action-wrapper"}>
              <Button
                data={{
                  btnName: "REFRESH",
                  buttonType: "border",
                  buttonSize: "sm x",
                  isLoading: isLoading,
                }}
                onClick={async (e) => {
                  e.preventDefault();
                  await onClickRefresh(e);
                }}
              />
            </div>
          </div>

          <div className="hne-jobs-body-wrapper">
            <Scrollbars
              onScroll={handleOnScroll}
              renderView={(props) => (
                <div
                  {...props}
                  style={{ ...props.style, overflowX: "hidden" }}
                />
              )}
              style={{ height: viewPointHeight - 300 }}
            >
              {Array.isArray(jobList) && jobList.length > 0 ? (
                [...jobList]
                  .sort(
                    (a, b) => new Date(b.created_at) - new Date(a.created_at)
                  )

                  .map((jobs) => (
                    <AdminJobsCard
                      isSelect={selectJobs === jobs?.job_id}
                      logo={jobs?.banner_img?.file_url || jobs?.banner_img}
                      titleEn={jobs?.job_title?.en}
                      titleSi={jobs?.job_title?.si}
                      closeDate={jobs?.closing_date}
                      // name={jobs?.organization}
                      name={fetchOrganizationName(jobs?.organization)}
                      views={jobs?.views}
                      type="admin"
                      view="View"
                      edit="Edit"
                      delete="Delete"
                      onClickView={() => {
                        // setSelectMenu(menus?.menu_id);
                        // dispatch(setMenu(menus));
                      }}
                      onClickEdit={() => {
                        setSelectJobs(jobs?.job_id);
                        dispatch(setJobs(jobs));
                      }}
                      onClickRemove={async () => {
                        setIsLoading(true);
                        try {
                          let result = await deleteJobs(jobs?.job_id);
                          console.log("Delete Jobs  Result: ", result);
                          if (result?.data) {
                            Store.addNotification({
                              title: "Success",
                              message: "Jobs successfully deleted",
                              type: "success",
                              container: "top-right",
                              dismiss: {
                                duration: 2000,
                                onScreen: true,
                              },
                            });
                            await onClickRefresh();
                          }
                        } catch (error) {
                          console.log("Error deleting Jobs ", error);
                          Store.addNotification({
                            title: "Error",
                            message: "Failed to delete jobs ",
                            type: "danger",
                            container: "top-right",
                            dismiss: {
                              duration: 2000,
                              onScreen: true,
                            },
                          });
                        }
                      }}
                    />
                  ))
              ) : (
                <div className="error-message">No Jobs Found</div>
              )}
            </Scrollbars>
          </div>
        </div>

        {/*right side*/}
        <div className="col-4 jobs-right-side-wrapper">
          <CreateNewJob refresh={onClickRefresh} />
        </div>
      </div>
    </>
  );
};
export default withRouter(Jobs);
